<template>
  <div class="cookie-policy-bar" v-show="show">
    <div class="container">
      <div class="row">
        <div class="col-sm-9 cookie-policy-bar-left">
          We use cookies to ensure that we give you the best experience on our website. <a href="https://www.london.gov.uk/cookies/" target="_blank">Read more about our cookie policy</a>
        </div>
        <div class="col-sm-3 text-right cookie-policy-bar-right">
          <button @click="acceptCookies">OK. got it</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      show: false
    }
  },

  methods: {
    acceptCookies () {
      this.$cookie.set('cookie-agreed', '2', {
        expires: '3M',
        path: '/'
      });
      this.show = false;
      this.$emit('cookieBanner', 'closed');
    }
  },

  created () {
    if (this.$cookie.get('cookie-agreed') !== '2') {
      this.show = true;
      this.$emit('cookieBanner', 'open');
    }
  }
}
</script>

<style lang="scss" scoped>
  .row {
    margin: 0;
  }

  .cookie-policy-bar {
    width: 100%;
    display: block;
    background: #C2C5C6;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    color: #353d42;
    font-size: 14px;
    z-index: 1000;

    &.unstuck {
      position: static;
    }
  }

  .cookie-policy-bar-left {
    padding: 7px 20px;
  }

  .cookie-policy-bar-right {
    padding: 7px 20px;
  }

  .cookie-policy-bar button,
  .cookie-policy-bar a {
    background: none;
    border: none;
    color: #353d42;
    text-decoration: underline;
    cursor: pointer;
  }
</style>





// WEBPACK FOOTER //
// src/components/CookieBanner.vue